<template>
  <div id="app">
    <v-app id="inspire">
      <v-navigation-drawer v-model="drawer" app clipped>
        <v-list>
          <!-- <v-list-item
            @click="$router.push('/')"
            :class="{ 'v-list-item--active' :  $route.name === 'home'}"
            color="primary"
          >
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-title>Home</v-list-item-title>
          </v-list-item> -->

          <v-list-group
            prepend-icon="sports_soccer"
            :value="$route.path.includes('football')"
          >
            <template v-slot:activator>
              <v-list-item-title>Piłka nożna</v-list-item-title>
            </template>

            <v-list-group
              no-action
              sub-group
              :value="$route.path.includes('football/today')"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Dzisiaj</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                @click="$router.push('/football/today/1x2')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-1x2'}"
                link
              >
                <v-list-item-title>1x2</v-list-item-title>
              </v-list-item>
             <v-list-item
                @click="$router.push('/football/today/xht')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-xht'}"
                link
              >
                <v-list-item-title>X HT</v-list-item-title>
              </v-list-item>
             <v-list-item
                @click="$router.push('/football/today/xft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-xft'}"
                link
              >
                <v-list-item-title>X FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/today/xhtft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-xhtft'}"
                link
              >
                <v-list-item-title>X HT/FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/today/1221')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-1221'}"
                link
              >
                <v-list-item-title>1/2 - 2/1</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/today/btts')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-btts'}"
                link
              >
                <v-list-item-title>BTTS</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/today/over05ht')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-over05ht'}"
                link
              >
                <v-list-item-title>Over 0.5 HT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/today/over15ht')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-over15ht'}"
                link
              >
                <v-list-item-title>Over 1.5 HT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/today/over25ft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-over25ft'}"
                link
              >
                <v-list-item-title>Over 2.5 FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/today/over35ft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-today-over35ft'}"
                link
              >
                <v-list-item-title>Over 3.5 FT</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              sub-group
              :value="$route.path.includes('football/tomorrow')"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Jutro</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                @click="$router.push('/football/tomorrow/1x2')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-1x2'}"
                link
              >
                <v-list-item-title>1x2</v-list-item-title>
              </v-list-item>
             <v-list-item
                @click="$router.push('/football/tomorrow/xht')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-xht'}"
                link
              >
                <v-list-item-title>X HT</v-list-item-title>
              </v-list-item>
             <v-list-item
                @click="$router.push('/football/tomorrow/xft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-xft'}"
                link
              >
                <v-list-item-title>X FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/tomorrow/xhtft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-xhtft'}"
                link
              >
                <v-list-item-title>X HT/FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/tomorrow/1221')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-1221'}"
                link
              >
                <v-list-item-title>1/2 - 2/1</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/tomorrow/btts')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-btts'}"
                link
              >
                <v-list-item-title>BTTS</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/tomorrow/over05ht')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-over05ht'}"
                link
              >
                <v-list-item-title>Over 0.5 HT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/tomorrow/over15ht')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-over15ht'}"
                link
              >
                <v-list-item-title>Over 1.5 HT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/tomorrow/over25ft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-over25ft'}"
                link
              >
                <v-list-item-title>Over 2.5 FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/football/tomorrow/over35ft')"
                :class="{ 'v-list-item--active' :  $route.name === 'football-tomorrow-over35ft'}"
                link
              >
                <v-list-item-title>Over 3.5 FT</v-list-item-title>
              </v-list-item>
            </v-list-group>

          </v-list-group>
          <v-list-group
            prepend-icon="sports_handball"
            :value="$route.path.includes('handball')"
          >
            <template v-slot:activator>
              <v-list-item-title>Piłka ręczna</v-list-item-title>
            </template>

            <v-list-group
              no-action
              sub-group
              :value="$route.path.includes('handball/today')"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Dzisiaj</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="$router.push('/handball/today/xht')"
                :class="{ 'v-list-item--active' :  $route.name === 'handball-today-xht'}"
                link
              >
                <v-list-item-title>X HT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/handball/today/xft')"
                :class="{ 'v-list-item--active' :  $route.name === 'handball-today-xft'}"
                link
              >
                <v-list-item-title>X FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/handball/today/xhtft')"
                :class="{ 'v-list-item--active' :  $route.name === 'handball-today-xhtft'}"
                link
              >
                <v-list-item-title>X HT/FT</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              sub-group
              :value="$route.path.includes('handball/tomorrow')"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Jutro</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                @click="$router.push('/handball/tomorrow/xht')"
                :class="{ 'v-list-item--active' :  $route.name === 'handball-tomorrow-xht'}"
                link
              >
                <v-list-item-title>X HT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/handball/tomorrow/xft')"
                :class="{ 'v-list-item--active' :  $route.name === 'handball-tomorrow-xft'}"
                link
              >
                <v-list-item-title>X FT</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/handball/tomorrow/xhtft')"
                :class="{ 'v-list-item--active' :  $route.name === 'handball-tomorrow-xhtft'}"
                link
              >
                <v-list-item-title>X HT/FT</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <!-- <v-list-item
            @click="$router.push('/contact')"
            :class="{ 'v-list-item--active' :  $route.name === 'contact'}"
            color="primary"
          >
            <v-list-item-icon>
              <v-icon>mail_outline</v-icon>
            </v-list-item-icon>

            <v-list-item-title>Kontakt</v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app clipped-left dark color="primary">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-btn href="/" text flat>
          <v-toolbar-title>Baza Typera</v-toolbar-title>
        </v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn
          href="https://tipanddonation.com/bazatypera"
          target="_blank"
          color="warning"
          depressed
        >
          Wesprzyj
        </v-btn> -->
      </v-app-bar>

      <v-content>
        <router-view />
        <v-footer>
          <v-flex xs12 class="mt-1 d-flex justify-center">
            <small>&copy; 2024 Baza Typera</small>
          </v-flex>
        </v-footer>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    drawer: false
  }),
  created() {
    if (this.$vuetify.breakpoint.width > 1264) {
      this.drawer = true
    }
  },
  computed: {
    today () {
      return moment().format('DD.MM.YYYY')
    },
    tomorrow () {
      return moment().add(1, 'days').format('DD.MM.YYYY')
    }
  }
}
</script>

<style lang="scss">
.v-list-item__title {
  text-align: left;
}

.table--with-links {
  .v-data-table {
    &__button {
      margin: 4px;
    }

    &__mobile-row__cell {
      .v-data-table__button {
        margin: 0 0 8px 8px;
      }
    }

    &__mobile-row {
      display: flex;
      align-items: center;
      min-height: 48px;
      height: auto;

      &__wrapper {
        width: 100%;
      }

      &__header {
        white-space: nowrap;
      }

      &:last-child {
        .v-data-table__mobile-row__header {
          margin-bottom: 8px;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .v-application--is-ltr .v-data-footer .v-data-footer__icons-after .v-btn:first-child {
    margin-left: 0;
  }

  .v-application--is-ltr .v-data-footer .v-data-footer__icons-before .v-btn:last-child {
    margin-right: 0;
  }

  .v-application--is-ltr .v-data-footer .v-data-footer__pagination {
      margin: 0 8px;
  }

  .v-application--is-ltr .v-data-table .v-data-footer__select .v-select {
    margin-left: 24px;
  }

  .v-data-table-header-mobile {
    display: none;
  }
}

</style>
